// remove legacy routes after 6 months, check git history
export const legacyRoutes = {
  // example
  // '/home/feedbacksOneToOne': '/home/oneOnOne/overview/myOneOnOne/registered',
};
